export default "__VITE_ASSET__B5jynKF4__"